// Core
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Box, Image, Grid, Text, Spinner, useDisclosure } from '@chakra-ui/react';
import { MdToken } from 'react-icons/md';
import { useHistory } from "react-router-dom";

// Assets
import { models } from '../../components/Settings/Models.js';
import StarsButton from '../../components/Button/Button';

const Home = ({activeModel}) => {
	const history = useHistory();

	const handleStart = () => {
	    history.push('/play');
	};

	return (
		<>
			<Image src={models[activeModel ?? 0].src} h="100vh" objectFit="cover" w="100%" />

			<Box position="absolute" bottom="80px" left="50%" transform="translate(-50%, 0px)">
				<Box position="relative">
				<StarsButton text="start" pt="100px" onClick={handleStart} />
				</Box>
			</Box>
		</>
	);
};

export default Home;